import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M7.99093 17.0001C7.78293 17.0001 7.57293 16.9361 7.39293 16.8011C6.95093 16.4701 6.86093 15.8441 7.19093 15.4021L9.73293 12.0031L7.19093 8.60406C6.85993 8.16206 6.95093 7.53506 7.39293 7.20406C7.83593 6.87306 8.46293 6.96506 8.79293 7.40606L11.7829 11.4041C12.0489 11.7591 12.0489 12.2471 11.7829 12.6021L8.79293 16.6001C8.59693 16.8611 8.29593 17.0001 7.99093 17.0001V17.0001Z"
      fill="currentColor"
    />
    <path
      d="M13.0009 17C12.7929 17 12.5829 16.936 12.4029 16.801C11.9609 16.47 11.8709 15.844 12.2009 15.402L14.7429 12.003L12.2009 8.60504C11.8699 8.16304 11.9609 7.53604 12.4029 7.20504C12.8459 6.87404 13.4729 6.96604 13.8029 7.40704L16.7929 11.405C17.0589 11.76 17.0589 12.248 16.7929 12.603L13.8029 16.601C13.6059 16.861 13.3059 17 13.0009 17V17Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'DoubleArrowRight');

export default Icon;
